/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
/* eslint-disable no-lonely-if */
/* eslint-disable radix */
/* eslint-disable camelcase */
import React from 'react';

export const imagePath =
  'https://swmc-landingpages.s3.amazonaws.com/common/images/wholesale-websites';

export const thumbnailImagePath =
  `${process.env.REACT_APP_SWMC_CDN}swmc-images/thumbnails`;

export const generateYtThumbnail = idPassed =>
  `${thumbnailImagePath}/${idPassed}.jpg`;

export const generateYtVideoLink = idPassed =>
  `https://www.youtube.com/watch?v=${idPassed}&authuser=0`;

export const dragElement = (elmnt, holderEle) => {
  // (myDIv, myDiveader is holding element for this for this)
  // console.log('DragFn:', elmnt)
  let pos1 = 0;
  let pos2 = 0;
  let pos3 = 0;
  let pos4 = 0;
  if (document.getElementById(`${elmnt.id}header`)) {
    /* if present, the header is where you move the DIV from: */
    document.getElementById(`${elmnt.id}header`).onmousedown = dragMouseDown;
  } else if (holderEle && holderEle.length > 0) {
    /* if present, the header is where you move the DIV from: */
    holderEle[0].onmousedown = dragMouseDown;
  } else {
    /* otherwise, move the DIV from anywhere inside the DIV: */
    elmnt.onmousedown = dragMouseDown;
  }

  function dragMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
    // get the mouse cursor position at startup:
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onmousemove = elementDrag;
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    // calculate the new cursor position:
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    // set the element's new position:
    elmnt.style.top = `${elmnt.offsetTop - pos2}px`;
    elmnt.style.left = `${elmnt.offsetLeft - pos1}px`;
  }

  function closeDragElement() {
    /* stop moving when mouse button is released: */
    document.onmouseup = null;
    document.onmousemove = null;
  }
};
